import React from 'react';
import { Link } from 'react-router-dom';
import SkeletonWrapper from '../skeleton/SkeletonWrapper';
import Nbsp from '../Nbsp';

/**
 * @typedef {object} BreadcrumbProps
 * @property {React.ReactNode} [children]
 * @property {Array<Object>} [pathItems]
 * @property {Array<React.ReactNode>} [annotationItems]
 * @property {boolean} [loading]
 */

/**
 * @param {BreadcrumbProps} props
 */
export const Breadcrumb = props => {
  const { children, annotationItems, pathItems = [], loading = false } = props;

  return (
    <nav className='breadcrumb' aria-label='breadcrumb' role='breadcrumb'>
      <div>
        {buildPath(pathItems)}
        {annotationItems && (
          <SkeletonWrapper
            show={loading}
            renderComponent={() => buildAnnotation(annotationItems)}
          />
        )}
      </div>
      {children}
    </nav>
  );
};

const buildPath = items => {
  if (!items || items.length <= 0) {
    return;
  }

  const breadcrumbs = items.map((page, index) => {
    if (index < items.length - 1) {
      return (
        <span key={index}>
          <Link to={page.url}>{page.name}</Link>
          <Nbsp />
          &gt;
          <Nbsp />
        </span>
      );
    }
    return <span key={index}>{page.name}</span>;
  });

  return (
    <div className='breadcrumbs' data-testid='breadcrumbs'>
      {breadcrumbs}
    </div>
  );
};

const buildAnnotation = items => {
  if (!items.length) return null;

  const processedItems = items
    .map((item, index) => {
      return typeof item === 'string' ? <span key={index}>{item}</span> : item;
    })
    .reduce((res, curr) => [res, ' > ', curr]);

  return <div className='annotation'>{processedItems}</div>;
};
